import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@shared/lib/http/axiosBaseQuery";
import { DocumentSettings } from "@models/document-settings";

export const documentsSettingsApi = createApi({
  reducerPath: "documentsSettingsApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/api/" }),
  tagTypes: ["DocumentsSettings"],
  endpoints: (b) => ({
    getDocumentsSettings: b.query<DocumentSettings[], void>({
      query: () => ({ url: "documents-settings" }),
      providesTags: ["DocumentsSettings"],
    }),

    editDocumentSettings: b.mutation<DocumentSettings, DocumentSettings>({
      query: (documentSettingsToUpdate) => ({
        url: `documents-settings/${documentSettingsToUpdate.id}`,
        method: "PATCH",
        data: documentSettingsToUpdate,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          documentsSettingsApi.util.updateQueryData("getDocumentsSettings", undefined, (draft) => {
            const row = draft.find((t) => t.id === arg.id);
            if (row) Object.assign(row, arg);
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: (_res, _err, documentSettingsToUpdate) => [
        { type: "DocumentsSettings" as const, id: documentSettingsToUpdate.id },
      ],
    }),
  }),
});

export const {
  useGetDocumentsSettingsQuery,
  useLazyGetDocumentsSettingsQuery,
  useEditDocumentSettingsMutation,
} = documentsSettingsApi;
